// 멀티테넌시 org 스코프 헬퍼 — 모든 Firestore 조회·쓰기는 이 모듈을 거쳐 orgId로 격리한다
import {
  collection,
  query,
  where,
  type Query,
  type QueryConstraint,
  type DocumentData,
} from "firebase/firestore";
import { db } from "@/lib/firebase";

/**
 * 3단계 호환 전환(제품화-실행계획.md 2절)의 B단계 폴백.
 * claims에 orgId가 없는 사용자(=전환 전 운영 사용자)는 org#1(FREEMILK)로 간주한다.
 * C단계(claims+rules 스위치) 이후에도 무해 — claims가 있으면 그 값이 우선.
 */
export const DEFAULT_ORG_ID = "freemilk";

let currentOrgId: string = DEFAULT_ORG_ID;

/** 로그인 시 auth 스토어가 호출 — claims.orgId ?? DEFAULT_ORG_ID */
export function setCurrentOrgId(orgId: string | null | undefined) {
  currentOrgId = orgId || DEFAULT_ORG_ID;
}

export function getCurrentOrgId(): string {
  return currentOrgId;
}

/** org 스코프 where 절 — 직접 query를 조립해야 하는 곳에서 사용 */
export function orgWhere(): QueryConstraint {
  return where("orgId", "==", currentOrgId);
}

/** org 스코프 컬렉션 쿼리 — collection(db, name) 직접 호출을 대체한다 */
export function orgQuery(name: string, ...cons: QueryConstraint[]): Query<DocumentData> {
  return query(collection(db, name), orgWhere(), ...cons);
}

/** 신규/병합 쓰기 데이터에 orgId를 강제 주입 — 모든 set/add 경로에서 사용 */
export function withOrg<T extends object>(data: T): T & { orgId: string } {
  return { ...data, orgId: currentOrgId };
}

/**
 * 고정 ID 문서의 org별 문서 ID — org 간 ID 충돌 방지.
 * 예: config/pricing → config/freemilk__pricing, schoolPrices/중앙초 → freemilk__중앙초
 */
export function orgDocId(base: string): string {
  return `${currentOrgId}__${base}`;
}

/** orgDocId 프리픽스 제거 — 레거시(프리픽스 없는) ID는 그대로 반환 */
export function stripOrgPrefix(id: string): string {
  const p = `${currentOrgId}__`;
  return id.startsWith(p) ? id.slice(p.length) : id;
}
